// extracted by mini-css-extract-plugin
export default {"image":"jgYOyM","lg":"hxNAN3"};